import React, { useEffect } from "react";

// plugin imports
import { ReactLenis } from "@studio-freight/react-lenis";
import { AnimatePresence, motion } from "framer-motion";

// style imports
import "../../styles/global.scss";
import "./Layout.scss";

// context imports

// component imports
import { Header } from "../Header/Header";
import { Footer } from "../Footer/Footer";
import CookiesBanner from "./cookiesBanner/cookiesBanner";

// util imports
import { slideUp } from "../../utils/animations";

// svg imports

// variables
export const pageTransitionDuration = 450;

// component

export const Layout = ({ location, children }) => {
	useEffect(() => {
		document?.documentElement.classList.add("pageAnimation");
		setTimeout(() => {
			document?.documentElement.classList.remove("pageAnimation");
		}, pageTransitionDuration);
	}, [location?.pathname]);

	return (
		<ReactLenis root>
			<Header />

			<main>
				<AnimatePresence mode="wait">
					<motion.div
						key={location?.pathname}
						{...slideUp}
						transition={{
							duration: pageTransitionDuration / 1000,
						}}
					>
						{children}
					</motion.div>
				</AnimatePresence>
			</main>

			<CookiesBanner />

			<Footer />
		</ReactLenis>
	);
};

export default Layout;
